<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <!-- memberList -->
          <div class="member-msg">
            <div class="member-border">
              <el-avatar class="img" shape="circle" size="small" v-if="memberList.headImgUrl" :src="memberList.headImgUrl"></el-avatar>
              <el-avatar shape="circle" size="small" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box">
                <p>{{ memberList.nickName }} {{ memberList.mobile ? memberList.mobile : memberList.idCardNo}}</p>
                <div class="flex-row mt5">
                  <p class="mobile">来源门店：{{memberList.shopName}}</p>
                  <p>可用余额: <span class="fontSize18">￥{{ memberList.walletAmount }}</span></p>
                </div>
              </div>
            </div>
          </div>
          <p class="order-title-boxs mtb24"><span class="blueBlock"></span><i>消费清单</i></p>
          <div class="totals-box pl24 mt20">
            <div class="flex-row mb30"  v-for="(item,index) in listSelected" :key="index">
              <div class="itemName">{{ item.categoryName }}</div>
              <div class="itemNum moneys">{{ item.salePrice }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">应收金额</div>
              <div class="itemNum moneys">{{ amount }}</div>
            </div>
            <div class="flex-row mb30" v-if="listSelected.length <= 1">
              <div class="itemName">卡券优惠</div>
              <div
									v-if="form.couponSendRecordId"
									@click="couponSelect()"
									class="itemNum moneys"
									>¥{{ couponAmount }}</div>
								<!-- <span
									v-else
									@click="couponSelect()"
									class="jishi cur"
									>请选择</span> -->
              <p v-else class="jishi cur" @click="couponSelect()">请选择 <i class="el-icon-arrow-right"></i></p>
            </div>
            <div class="align-item mb30">
              <div class="itemName">实收金额</div>
              <div class="inputs">
                <el-input class="input" v-model="form.orderAmount" placeholder="请输入" maxlength="8"
                  :disabled="couponAmount > 0" @keyup.native="form.orderAmount = isMoney(form.orderAmount)"></el-input>
              </div>
            </div>
          </div>
          <div class="pay-methods">
            <p class="order-title-boxs mtb24"><span class="blueBlock"></span><i>请选择收款方式</i></p>
            <div class="plr24 flex-row wraps">
              <div v-for="(item, index) in payWayList" :key="index" @click="payWayFun(item)"
                class="flex-row orderPayRadio" :class="[radio == item.payCode ? 'active' : '']">
                <div class="pay-img"><img :src="item.imgUrl" alt /></div>
                <div class="fontSize16">{{ item.payName }}</div>
                <div class="payCheak" v-if="radio == item.payCode"><img src="../../../assets/images/new/payRadio.png"
                    alt=""></div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <div class="flex-row">
              <p class>实收金额：</p>
              <p class="amount money">￥{{ form.orderAmount || 0 }}</p>
            </div>
            <el-button class="right-btn" @click="saveMoney">确定收款</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <payDialog v-if="dialogHide" title="支付效验" :bizType="'pay'" :hide="dialogHide" :oid="oid" :memberId="memberList.id"
      :price="Number(form.orderAmount)" :type="'repair'" :mobile="memberList.mobile" @changeDialog="savePay"></payDialog>
    <pay-form ref="payEditForm" @payFun="payMoney" :balance='balance' :amount="Number(form.orderAmount)"
      :foot="true"></pay-form>
    <quickTopUp ref="topUpForm" @handleChange="gotoTopUpPage" :isYuanJian="memberList.yuanjianTransferFlag"></quickTopUp>
    <member-top-up ref="memberTopUpForm" @memberChange="changeTopUp"></member-top-up>
    <confimDdialog ref="confimFrom" @handleChange="cashBack" :money="form.orderAmount" :payWay="radio"
      :showTitle="'repair'" :payWayDescription="form.payWayDescription"></confimDdialog>
    <yuan-jian-pay ref="yuanJianForm" @change="yuanJianChange"></yuan-jian-pay>
    <selectCoupon-set ref="selectCouponSetForm" @selectCouponChange="selectCouponChange"></selectCoupon-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import payDialog from "../../components/pay-dialog";
import payForm from "../../components/pay";
import quickTopUp from "../../components/quick-top-up";
import memberTopUp from "../member/topUp";
import confimDdialog from "../../components/confim-dialog";
import drawer from "../../../components/common/drawer";
import YuanJianPay from '../../components/yuanJianPay.vue';
import selectCouponSet from "../productFootBath/selectCoupon.vue";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
import { Loading } from 'element-ui'

export default {
  mixins: [minxin],
  components: { payDialog, quickTopUp, drawer, payForm, memberTopUp, confimDdialog, YuanJianPay, selectCouponSet },
  data() {
    return {
      radio: "",
      addEditTitle: "新建档案",
      addEditShow: false,
      isYuanjianTakeIn: false,//远舰钱是否转入过来
      memberList: {
        mobile: ""
      },
      headerImg: require("../../../assets/images/headerImg.png"),
      payWayList: [],
      parentForm: {},
      successImg: require("../../../assets/images/money/success.png"),
      mainHeight: this.$store.getters.MainHeight,
      listSelected: [],
      form: {
        orderAmount: "",
        couponSendRecordId: "",
      },
      noMoneyStatus: false,
      dialogHide: false,
      amount: 0,
      couponSendRecordId: "",
      couponAmount: 0,
      oid: '',
      balance: ''
    };
  },
  created() { },
  mounted() {
    this.inits();
  },
  methods: {
    handleChangeDrawer() {
      this.form.orderAmount = "";
      this.form.couponSendRecordId = "";
      this.couponSendRecordId = '';
      this.balance = ''
      this.couponAmount = 0;
      this.addEditShow = false;
    },
    inits() {
      this.$on("set", function (org) {
        this.addEditShow = true;
        this.form.orderAmount = "";
        this.form.couponSendRecordId = "";
        this.couponSendRecordId = '';
        this.balance = ''
        this.couponAmount = 0;
        console.log(org, 'org');
        if (org && org instanceof Array && org.length >= 1) {
          this.notLocalStorage(org);
        } else if (org && org instanceof Object) {
          this.parentForm = org;
          this.$api.get(this.$url.repairDocument.preparePay, { repairDocId: org.id }).then(res => {
            if (res) {
              res.map(item => {
                this.amount = item.salePrice;
              })
              this.listSelected = res;
            }
          });
          this.getMember(org.payMemberId);
        } else {
          this.notLocalStorage(org);
        }
        this.isMember();
      });
    },
    notLocalStorage (arg) {
      this.parentForm = arg
      this.amount = 0;
      this.parentForm.map(item => {
        this.amount += item.salePrice;
      })
      this.listSelected = this.parentForm;
      this.getMember(this.parentForm[0].payMemberId)
    },
    getMember(id) {
      // 获取会员信息
      this.$api.get(this.$url.member.get, { id: id }).then(res => {
        if (res) {
          this.memberList = res;
          this.form.memberId = res.id;
          if (this.isYuanjianTakeIn) {
            this.saveMoney();
          }
        }
      })
        .catch(error => { });
    },
    changeTopUp(org) {
      console.log(org, "org")
      let a = JSON.parse(localStorage.getItem("payMobile"))
      if (org) {
        this.$api.get(this.$url.member.search, {
          keyword: a.mobile,
          needIntegralFlag: true
        }).then(res => {
          if (res) {
            this.memberList = res.memberList[0];
          }
        })
      }
    },
    cashBack(val) {
      // 现金确定弹窗回调
      if (val) {
        this.form.millisecond = new Date().getTime();
        let parms = {
          memberId: this.form.memberId,
          payCheckType: this.form.payCheckType,
          payWay: this.form.payWay,
          verifyCode: this.form.verifyCode,
          repairDocIdList: this.form.repairDocIdList,
          orderAmount: (Number(this.form.orderAmount) + Number(this.couponAmount)).toFixed(2),
          couponSendRecordId: this.form.couponSendRecordId,
          millisecond: this.form.millisecond
        };
        const loadingInstance = Loading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$api.post(this.$url.repairDocument.payRepairBatch, encrypt(JSON.stringify(parms))).then(res => {
          if (res) {
            localStorage.removeItem("payMobile");
            loadingInstance.close()
            this.$refs["payEditForm"].$emit("set", res);
          } else {
            loadingInstance.close()
          }
        })
      }
    },
    gotoTopUpPage(org) {
      if (org && org != 'yuanjian') {
        this.$refs["memberTopUpForm"].$emit("set", this.memberList.id);
      } else if (org && org == 'yuanjian') {
        // yuanjianTransferFlag: true
        console.log(11111);
        // this.memberList.payPrice = this.form.orderAmount || 0;
        // this.$refs["yuanJianForm"].$emit("set", this.memberList);
        let obj = {
          payPrice: this.form.orderAmount,
          memberId: this.memberList.id,
          type: 'repair'
        }
        this.$refs['yuanJianForm'].$emit('set', obj)
      }

      // if (org) {
      //   this.$refs["memberTopUpForm"].$emit("set");
      //   // this.addEditShow = false;
      // }
    },
    saveMoney() {
      if (!this.form.orderAmount) {
        return this.$message.warning("请输入收款金额");
      } else if (!this.form.payWay) {
        return this.$message.error("请选择支付方式")
      }
      this.form.repairDocIdList = [];
      this.form.payCheckType = "";
      this.form.verifyCode = "";
      for (let i in this.listSelected) {
        this.form.repairDocIdList.push(this.listSelected[i].repairDocId);
      }
      this.form.memberId = this.memberList.id;

      this.$api.post(this.$url.repairDocument.checkMemberAccountAmount, {
        memberId: this.form.memberId,
        payWay: this.form.payWay,
        realPayAmount: this.form.orderAmount,
        orderType: "repair",
      }).then(res => {
        if (res.constructor !== Object) {
          if (!res) return;
          this.trueToPay();
        } else {
          if (res.status == 'accountAmountInsufficient') {
            localStorage.setItem("payMobile", JSON.stringify({
              id: this.form.id,
              mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
              path: this.$route.path,
              res: this.listSelected
            }));
            this.$refs["topUpForm"].$emit("set", "0");
          }
        }
      }).catch(error => { })
    },
    trueToPay() {
      if (this.form.payWay == "wallet") {
        if (this.memberList.walletAmount < this.form.orderAmount) {
          localStorage.setItem("payMobile", JSON.stringify({
            id: this.form.id,
            mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
            path: this.$route.path,
            res: this.listSelected
          }));
          this.$refs["topUpForm"].$emit("set", "0");
          return false;
        }

        let a = " "
        if (Number(this.amount) > Number((Number(this.form.orderAmount) + Number(this.couponAmount)).toFixed(2))) {
          const h = this.$createElement;
          this.$msgbox({
            title: '提示',
            message: h('p', null, [
              h('div', null, '本次新建档案将进行分期收款'),
              h('div', null, '分期付款最多分三次完成支付')
            ]),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true
          }).then(action => {
            localStorage.setItem("productType", 'repair')
            this.dialogHide = true;
          })
        } else {
          localStorage.setItem("productType", 'repair')
          this.dialogHide = true;
        }
      } else {
        if (Number(this.amount) > Number((Number(this.form.orderAmount) + Number(this.couponAmount)).toFixed(2))) {
          const h = this.$createElement;
          this.$msgbox({
            title: '提示',
            message: h('p', null, [
              h('div', null, '本次修护开卡将进行分期收款'),
              h('div', null, '分期付款最多分三次完成支付')
            ]),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true
          }).then(action => {
            this.$refs["confimFrom"].$emit("set", true);
          })
        } else {
          this.$refs["confimFrom"].$emit("set", true);
        }
      }
    },
    payMoney(org) {
      if (org) {
        this.form.orderAmount = "";
        this.$emit("handleChange", true)
        this.addEditShow = false;
      }
    },
    savePay(value) {
      if (value != "") {
        this.form.payCheckType = value.payCheckType;
        this.form.verifyCode = value.verifyCode;
        this.form.millisecond = new Date().getTime();

        let parms = {
          memberId: this.form.memberId,
          payCheckType: this.form.payCheckType,
          payWay: this.form.payWay,
          verifyCode: this.form.verifyCode,
          repairDocIdList: this.form.repairDocIdList,
          orderAmount: (Number(this.form.orderAmount) + Number(this.couponAmount)).toFixed(2),
          couponSendRecordId: this.form.couponSendRecordId,
          millisecond: this.form.millisecond
        };
        console.log("参数---", parms);
        const loadingInstance = Loading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$api.post(this.$url.repairDocument.payRepairBatch, encrypt(JSON.stringify(parms)))
          .then(res => {
            console.log("res:", res);
            if (res && res.status == 'fail') {
              this.dialogHide = false;
              loadingInstance.close()
              return this.$message.error(res.message)
            }
            if (res) {
              this.dialogHide = false;
              loadingInstance.close()
              this.isPayWayHide = false;
              // :balance='balance'
              this.balance = (Number(this.memberList.walletAmount) - Number(this.form.orderAmount)).toFixed(2)
              localStorage.removeItem("payMobile");
              this.$refs["payEditForm"].$emit("set", res);
            } else {
              loadingInstance.close()
              this.isPayWayHide = true;
              this.dialogHide = false;
            }
          });
      } else {
        this.dialogHide = false;
      }
    },
    payWayFun(item) {
      // this.dialogHide = false;
      this.form.payWay = item.payCode;
      this.form.payWayDescription = item.payName;
      this.radio = item.payCode;
    },
    isMember() {
      this.$api.get(this.$url.paywaySet.list, {
        isMember: true,
        sourceFrom: "repair",
        bizId: ""
      }).then(res => {
        if (res) {
          this.payWayList = res;
          for (let i in this.payWayList) {
            if (i == 0) {
              this.form.payWay = this.payWayList[0].payCode;
              this.radio = this.payWayList[i].payCode;
              this.$set(this.payWayList[i], "show", true);
            } else {
              this.$set(this.payWayList[i], "show", false);
            }
          }
        }
      });
    },
    yuanJianChange(org) {
      console.log(3333, org);
      if (org) {
        console.log(22222, this.parentForm);
        this.isYuanjianTakeIn = true;
        this.getMember(this.form.memberId);
      }
    },
    couponSelect() {
      let a = [];
      this.listSelected.map((item) => {
        let dic = { "itemId": item.itemId, "realPayAmount": item.salePrice }
        a.push(dic)
      })
      this.$refs['selectCouponSetForm'].$emit('set', {
        memberId: this.memberList.id,
        realPayAmount: this.amount,
        orderItemList: a,
        couponSendRecordId: this.couponSendRecordId,
      })
    },
    selectCouponChange(org) {
      if (org.id) {
        // this.isSelectCoupon = true;
        this.form.couponSendRecordId = org.id;
        this.couponSendRecordId = org.id;
        this.couponAmount = org.couponAmount;

        this.form.orderAmount = (Number(this.amount) - Number(this.couponAmount)).toFixed(2);
      } else {
        // this.isSelectCoupon = false;
        this.form.couponSendRecordId = "";
        this.couponSendRecordId = '';
        this.couponAmount = 0;

        this.form.orderAmount = "";
      }
    },
  }
};
</script>
<style>
.payway-success .el-button+.el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.pay-mains {
  position: relative;
  height: calc(100vh - 140px);

  .member-msg {
    padding: 16px 16px 0;

    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: #3388ff;
      box-sizing: border-box;

      .member-box {
        margin-left: 10px;

        .mobile {
          line-height: 1.6;
          margin-right: 10px;
        }
      }
    }
  }

  .pay-methods {
    width: 100%;
    position: absolute;
    bottom: 30px;

    .orderPayRadio {
      box-sizing: border-box;
      width: 32%;
      height: 56px;
      background: #FFFFFF;
      border: 1px solid #DCDEE0;
      border-radius: 4px;
      align-items: center;
      padding-left: 16px;
      cursor: pointer;
      position: relative;
      margin-right: 2%;
      margin-bottom: 10px;

      &:nth-of-type(3n) {
        margin-right: 0 !important;
      }

      .payCheak {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 0;
        right: 0;
      }

      .pay-img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .active {
      color: #3388FF;
      border: 1px solid #3388FF;
      background: #EAF4FE;
    }
  }
}

.member_bg {
  width: 600px;
  height: 40px;
  background-image: url("../../../assets/images/money/gou.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .flex-row {
    align-items: center;

    .img {
      width: 30px;
      height: 30px;
      margin-left: 10px;
    }
  }
}

.right-footer {
  align-items: center;
  border-top: 1px solid #f1f2f2;
  padding: 38px 35px;
  justify-content: space-between;
}

/deep/.el-radio-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: space-between;

  .el-radio {
    margin-right: 0;
    text-align: center;
    width: 37%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    height: 48px;
    border: 1px solid @borderColor;
    border-radius: 10px;

    .el-radio__label {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;

      p {
        width: 100px;
      }

      img {
        width: 32px;
        height: 32px;
      }
    }

    .el-radio__inner {
      width: 22px;
      height: 22px;
    }
  }
}

/deep/ div .el-radio__label {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  width: 60%;

  .label-boxs {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
  }
}

.drawer-footer {
  .btns {
    display: flex;

    .flex-row {
      align-items: center;
      margin-right: 40px;
      font-weight: 500;
      font-size: 16px;

      .money {
        color: @money;
      }
    }
  }
}

.btns {
  width: 100%;
  display: flex;
  padding: 10px 24px 10px;
  border-top: 1px solid #EEE;

  .left-btn {
    width: 176px;
    height: 56px;
    color: #fff;
    font-size: 20px;
    background: #535A6C;
    border-radius: 4px;
  }

  .right-btn {
    flex: 1;
    width: 100%;
    color: #fff;
    font-size: 20px;
    height: 56px;
    background: #FF5449;
    border-radius: 4px;
  }
}
</style>